// extracted by mini-css-extract-plugin
export default {"root":"CardList_root__dnEue","form":"CardList_form__w5Wte","form_wrap":"CardList_form_wrap__+BvfS","card":"CardList_card__f3XzT"};